import { prefixerT } from '.'

export const ROUTE_CIERRE_CONTABLE = prefixerT('cierre-contable')
export const ROUTE_EXPORTAR_DIARIO = prefixerT('exportar-diario')
export const ROUTE_IMPORTAR_DIARIO = prefixerT('importar-diario')
export const ROUTE_TRANSACCIONES_CONTABLES = prefixerT('transacciones-contables')
